import UserInfoSummary, {UserInfoSummaryProps} from './UserInfoSummary';

export type {UserInfoSummaryProps};
export default UserInfoSummary;
